import { render, staticRenderFns } from "./PlayerOfTheMatchWidget.vue?vue&type=template&id=4b52c825&scoped=true"
import script from "./PlayerOfTheMatchWidget.vue?vue&type=script&lang=js"
export * from "./PlayerOfTheMatchWidget.vue?vue&type=script&lang=js"
import style0 from "./PlayerOfTheMatchWidget.vue?vue&type=style&index=0&id=4b52c825&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b52c825",
  null
  
)

export default component.exports